import { FormFieldProps, readValue, writeValue } from "./FormField";
import React, { ChangeEvent, Component } from "react";

interface Props extends FormFieldProps<boolean> {
	inputClassName?: string;
	errorInputClass?: string;
	labelHREF?: string;
	targetHREF?: string;
}

class CheckBoxField extends Component<Props> {
	static defaultProps: Partial<Props> = {
        containerClassName: "form-check",
        inputClassName: "form-check-input",
        labelClassName: "form-check-label",
		errorInputClass: "form-input-error",
		errorClassName: "invalid-feedback invalid-feedback-x"
	};

	onChange = ( event: ChangeEvent<HTMLInputElement> ) => {
		let value = event.target.checked;
		if ( this.props.onValueChange ) {
			this.props.onValueChange( value );
		}
		writeValue( this.props, value );
	};

	render() {
		const {
			id,
			containerClassName,
			inputClassName,
			labelClassName,
			label,
			required,
			error,
			errorInputClass,
			errorClassName,
			labelHREF,
			targetHREF
		} = this.props;
		const inpProps = {
			id: id,
			onChange: this.onChange,
			className: inputClassName + ( error ? ` ${ errorInputClass }` : "" ),
			type: "checkbox",
			checked: readValue( this.props ),
		};
		return (
			<React.Fragment>
                <div className={ containerClassName }>
                    <input  {...inpProps} />
                    <label className={labelClassName} htmlFor={id}>
                        <span>{label}</span>
                        {labelHREF && <a
                            href="#" className="btn-link" data-bs-toggle="modal"
                            data-bs-target={targetHREF}>{labelHREF}</a>}
                        {required && <span className="asterisk">*</span>}
                    </label>
                    {error && <div className={errorClassName}>{error}</div>}
                </div>
			</React.Fragment>
		);
	}
}

export default CheckBoxField;
